<template>
  <div id="crawl-page">
    <div class="row mb-4" style="margin-top: 15px">
      <div class="col-12 col-xl-4 px-gap">
        <div class="form-group m-b-10">
          <label for="type">Crawl Type:</label>
          <select class="rounded mx-1 form-control" v-model="form_sync.sync" @change="changeTypeSync">
            <option value="streams" selected>Streams</option>
            <option value="quotes">Quotes</option>
            <option value="twitter">Twitter</option>
            <option value="twitter_trending">Twitter Trending</option>
          </select>
        </div>

        <div class="bg-white p-t-5 p-b-5 d-flex align-items-center p-l-15 p-r-15 rounded shade">
          <!-- title -->
          <h3 style="font-size: 20px">
            <i class="bi bi-card-checklist me-2"></i>
            Crawling Manual
            <i class="ms-4 bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'groupHelper' }"></i>
          </h3>
          <!-- tooltip helper -->
          <div ref="groupHelper" class="tooltip-content">
            <div>
              <b>Crawling Manual</b> digunakan ketika diperlukan untuk mengambil data secara menual
            </div>
          </div>
        </div>
        <div class="bg-white m-t-15 p-t-5 p-b-5 d-flex align-items-center p-l-15 p-r-15 rounded shade">
          <form class="w-100">
            <div class="form-group">
              <label for="start_date" class="required">Start Date (YYYY-MM-DD)</label>
              <v-date-picker is-required mode="date" v-model="form_sync.start_date" :min-date="'2024-01-01'">
                <template v-slot="{ inputValue, togglePopover }">
                  <input class="bg-white border px-2 py-1 rounded form-control" id="start_date" :value="inputValue"
                    :disabled="syncStatus === 'process'" @click="togglePopover()" required style="cursor: pointer"
                    placeholder="Select Date" />
                </template>
              </v-date-picker>
              <div v-if="errors.start_date" class="text-danger">{{ errors.start_date }}</div>
            </div>

            <div class="form-group">
              <label for="end_date" class="required">End Date (YYYY-MM-DD)</label>
              <v-date-picker is-required mode="date" v-model="form_sync.end_date" :min-date="'2024-01-01'">
                <template v-slot="{ inputValue, togglePopover }">
                  <input class="bg-white border px-2 py-1 rounded form-control" id="end_date" :value="inputValue"
                    :disabled="syncStatus === 'process'" @click="togglePopover()" required style="cursor: pointer"
                    placeholder="Select Date" />
                </template>
              </v-date-picker>
              <div v-if="errors.end_date" class="text-danger">{{ errors.end_date }}</div>
            </div>

            <div class="form-group m-b-10 d-none">
              <label for="type">Type</label>
              <select id="type" name="type" class="form-control" ref="select2" v-model="form_sync.type"
                disabled>
                <option value="">Select type</option>
                <option value="medkon">Media Online</option>
                <option value="medsos">Media Sosial</option>
              </select>
              <div v-if="errors.type" class="text-danger">{{ errors.type }}</div>
            </div>

            <div class="form-group m-t-15">
              <button type="button" class="btn btn-success m-r-5" @click="startSync()"
                :disabled="syncStatus === 'process'">
                Start
              </button>
              <!-- <button type="button" class="btn btn-danger" disabled>Stop</button> -->
            </div>
          </form>
        </div>
      </div>
      <div class="col-12 col-xl-8 px-gap">
        <div class="bg-dark p-t-5 p-b-5 vh-75 d-flex flex-column w-100 p-3 p-t-10 p-b-10" id="logContainer">
          <!-- Logs will be displayed here -->
          <div v-for="(log, index) in logs" :key="index" class="log-entry m-t-1 m-b-1">
             <span class="debug m-t-1 m-b-1">{{ log }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
label.required::after {
  content: "*";
  color: rgb(220, 0, 0);
  margin-left: .3rem;
}

.vh-75 {
  height: 75vh !important
}

span.debug::before {
  content: "$";
  display: inline-block;
  padding-right: 5px;
  font-weight: 100;
  color: #f6af14;
}

span.info::before {
  content: "$";
  display: inline-block;
  padding-right: 5px;
  font-weight: 100;
  color: #f6af14;
}

span.debug {
  font: 11pt/1.25 Monaco, monospace;
  color: Snow;
}

#logContainer {
  overflow-y: auto;
}

.dark-mode .select2-container .selection .select2-selection,
.dark-mode .select2-search .select2-search__field {
  border: rgba(184, 192, 202, 0.5) 0.3px solid !important;
}

.dark-mode .select2-dropdown {
  border: rgba(184, 192, 202, 0.5) 0.3px solid !important;
}

.select2-container--default .select2-selection--single .select2-selection__placeholder {
  color: #595f70 !important;
}


div.text-danger {
  color: #ff3a3a !important;
}
</style>

<script>
import $ from 'jquery';
import 'select2';
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import swal from "sweetalert";
import axios from 'axios';

export default {
  name: 'crawl_manual',
  components: {
    "v-date-picker": DatePicker,
  },
  data() {
    return {
      logs: [],
      form_sync: {
        sync: "streams",
        start_date: null,
        end_date: null,
        type: null,
      },
      errors: {
        start_date: '',
        end_date: '',
      },
      syncStatus: '',
      selectedType: '',
    };
  },
  sockets: {
    log(data) {
      if (this.form_sync.sync == data?.type){
        this.addLog(data?.msg);
      }
      if(data?.done) {
        this.checkData()
      }
    },
    message(data) {
      console.log('Message received:', data);
    },
  },
  methods: {
    // method select2
    initializeSelect2() {
      $(this.$refs.select2).select2({
        placeholder: 'Select type',
        allowClear: true,
      });

      // Sync value with Vue data
      $(this.$refs.select2).on('select2:select', (e) => {
        this.selectedType = e.target.value;
      });

      $(this.$refs.select2).on('select2:unselect', () => {
        this.selectedType = '';
      });
    },
    // method sync start
    startSync() {
      this.errors = {
        start_date: '',
        end_date: '',
        type: '',
      };

      // Validate the form
      let isValid = true;

      // Check if start date is empty
      if (!this.form_sync.start_date) {
        this.errors.start_date = 'Start Date is required';
        isValid = false;
      }

      // Check if end date is empty
      if (!this.form_sync.end_date) {
        this.errors.end_date = 'End Date is required';
        isValid = false;
      }

      // Check if start date is greater than end date
      if (this.form_sync.start_date && this.form_sync.end_date) {
        const startDate = new Date(this.form_sync.start_date);
        const endDate = new Date(this.form_sync.end_date);

        if (startDate > endDate) {
          this.errors.start_date = 'Start Date cannot be after End Date';
          this.errors.end_date = 'End Date cannot be before Start Date';
          isValid = false;
        }
      }

      this.form_sync.start_date = new Date(this.form_sync.start_date).toISOString().split('T')[0];
      this.form_sync.end_date = new Date(this.form_sync.end_date).toISOString().split('T')[0];

      if (isValid) {
        let data = this.form_sync

        swal({
          title: "Apakah anda yakin?",
          // text: "untuk manual crawl manual ini ?",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "sync-manual";
            axios
              .post(api, data)
              .then((response) => {
                if (response.status == 200) {
                  this.$parent.isLoading = true;
                  // this.resetForm(this.form_sync.sync)
                  this.syncStatus = "process";
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Sync berhasil dijalankan.',
                      position: "top",
                      timeout: 4000,
                      type: "success",
                    })
                    .show();
                } else {
                  // Handle the failure scenario with a sweetalert
                  swal(
                    "Error!",
                    "Gagal start sync. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                // Handle network or server error
                swal(
                  "Error!",
                  "Terjadi kesalahan saat start sync. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        });
      } else {
        console.log('Form is invalid, please fix the errors');
      }
    },
    // check sync status
    changeTypeSync() {
      this.logs = []
      this.checkData()
    },
    // check data sync
    checkData() {
      this.syncStatus = "";
      // this.form_sync.start_date = ""
      // this.form_sync.end_date = ""
      // this.form_sync.type = null

      let type = this.form_sync.sync;
      let params = { type: type };
      let api = process.env.VUE_APP_API_URL + "sync-status";

      axios
        .get(api, { params })
        .then((response) => {
          let data = response.data;
          if (type === data.sync_type) {
            this.syncStatus = "process";
            // this.form_sync.start_date = data?.sync?.start_date ?? null
            // this.form_sync.end_date = data?.sync?.end_date ?? null
            // this.form_sync.type = data?.sync?.type ?? null
          }
        })
        .catch((err) => {
          console.error("Error fetching sync status:", err);
        });
    },
    // add log
    addLog(message) {
      this.logs.push(message);  // Add message to logs array
      // Ensure the log container is scrolled to the bottom
      this.$nextTick(() => {
        const logContainer = document.getElementById('logContainer');
        logContainer.scrollTop = logContainer.scrollHeight;
      });
    }
  },
  mounted() {
    // init select
    this.initializeSelect2();
    // check data
    this.checkData();
  },
  beforeDestroy() {
    // Clean up Select2 instance
    $(this.$refs.select2).select2('destroy');
  },
};
</script>
